import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Container,
  alpha,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { useProject } from '../contexts/ProjectContext';

const Audience = () => {
  const { selectedProject } = useProject();

  if (!selectedProject) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">
          Please select a project to configure your target audience
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Audience
      </Typography>
      
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper 
          sx={{ 
            p: 6,
            textAlign: 'center',
            bgcolor: (theme) => alpha(theme.palette.primary.main, 0.03),
            border: '1px dashed',
            borderColor: 'primary.main',
          }}
        >
          <PeopleIcon 
            sx={{ 
              fontSize: 80, 
              color: 'primary.main',
              mb: 2,
              opacity: 0.8,
            }} 
          />
          <Typography variant="h5" gutterBottom color="primary" sx={{ fontWeight: 500 }}>
            Target Audience Setup
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
            Define and customize your target audience to generate more relevant and engaging content. Specify demographics, interests, and preferences to help our AI better understand who you're creating content for.
          </Typography>
          <Typography variant="body2" color="primary" sx={{ mt: 3, fontStyle: 'italic' }}>
            Coming soon...
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Audience; 